import { OutlinedInput, Stack } from '@mui/material';
import get from 'lodash-es/get';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useConstants } from '../../../../hooks/useConstants';
import CheckboxArray from '../../../forms/CheckboxArray';
import Select from '../../../forms/Select';

interface SizeProps {
  readOnly?: boolean;
  defaultValue?: string;
  fieldName?: string;
  options?: string[];
  checkboxes?: boolean;
}

export default function Size({ readOnly = false, defaultValue = null, fieldName = 'size', options: optionsParam, checkboxes = false }: SizeProps) {
  const { constants, getConstant } = useConstants();
  const { formState, getFieldState, getValues, resetField, watch } = useFormContext();

  const ACCEPTED_SIZES = get(constants, 'CREATIVE.ACCEPTED_SIZES', []);
  const dynamicOptions = getConstant ? get(getConstant('CREATIVE.ACCEPTED_SIZES'), 'values', null) : null;

  const acceptedSizes = optionsParam || ACCEPTED_SIZES;
  const options = dynamicOptions || acceptedSizes.map((obj) => ({ value: obj, label: obj }));

  const watchAdType = watch('adType');
  const { isDirty: isAdTypeDirty } = getFieldState('adType', formState);

  // Set the default value
  useEffect(() => {
    const fieldValue = getValues(fieldName);
    if (fieldValue === null && defaultValue !== null) {
      resetField(fieldName, { defaultValue });
    }
  }, [resetField, defaultValue, fieldName, getValues]);

  // If ad type changed and there is no value or the last saved value does not exist in the new dropdown
  // then set it to the default value.
  useEffect(() => {
    const fieldValue = getValues(fieldName);
    if (isAdTypeDirty) {
      if (fieldValue === null || !options.map((item) => item.value).includes(fieldValue)) {
        resetField(fieldName, { defaultValue });
      }
    }
  }, [isAdTypeDirty, resetField, defaultValue, fieldName, getValues, watchAdType, options]);

  return (
    <Stack>
      {readOnly && <OutlinedInput value={defaultValue} disabled />}
      {!readOnly && checkboxes && <CheckboxArray row name={fieldName} options={options} />}
      {!readOnly && !checkboxes && (
        <Select
          label="Size"
          name={fieldName}
          options={options}
          rules={{
            required: 'Please enter a size.',
          }}
        />
      )}
    </Stack>
  );
}
